<template>
  <div class="content">
    <div class="container-fluid h-100">
      <div class="container-fluid h-100">
        <div class="row h-100">
          <div class="col h-100">
            <card-item
              class="striped-tabled-with-hover"
              body-classes="table-full-width table-responsive"
            >
              <template slot="header">
                <div class="d-flex justify-content-between">
                  <div>
                    <h4 class="card-title">Clientes</h4>
                    <p class="card-category">Listado</p>
                  </div>
                  <div class="button-group">
                    <button @click="historialContratos" class="btn btn-warning">
                      Historial Contratos
                    </button>
                    <button @click="crearCliente" class="btn btn-primary">
                      Añadir Cliente
                    </button>
                  </div>
                </div>
              </template>

              <div class="container-fluid h-100">
                <div class="row">
                  <div class="col">
                    <div class="form-group">
                      <label for="quickFilter" class="label"
                        >Filtro rapido</label
                      >
                      <input
                        type="text"
                        class="form-control"
                        id="quickFilter"
                        v-model="quickFilterValue"
                      />
                    </div>
                  </div>
                </div>
                <div class="row" style="height: 100%">
                  <div class="col" style="position: relative; height: 100%">
                    <ag-grid-vue
                      style="width: 100%; height: 60vh"
                      class="ag-theme-alpine"
                      :columnDefs="columnDefs"
                      :defaultColDef="defaultColDef"
                      :gridOptions="gridOptions"
                      :rowData="rowData"
                      @grid-ready="onGridReady"
                      :modules="modules"
                      :getContextMenuItems="getContextMenuItems"
                    >
                    </ag-grid-vue>
                  </div>
                </div>
              </div>
            </card-item>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { AgGridVue } from "ag-grid-vue";
import { AllModules } from "ag-grid-enterprise";
import ClientesTablaActions from "./Tabla/ClientesTablaActions";

export default {
  name: "ClientesList",
  components: { AgGridVue },
  beforeMount() {
    this.gridOptions = {
      statusBar: {
        statusPanels: [
          {
            statusPanel: "agTotalAndFilteredRowCountComponent",
            align: "left",
          },
          {
            statusPanel: "agTotalRowCountComponent",
            align: "center",
          },
          { statusPanel: "agFilteredRowCountComponent" },
          { statusPanel: "agSelectedRowCountComponent" },
          { statusPanel: "agAggregationComponent" },
        ],
      },
      enableClipboard: true,
      enableRangeSelection: true,
    };
    this.defaultColDef = {
      sortable: true,
      filter: true,
      resizable: true,
      flex: 1,
      enableCellTextSelection: true,
      ensureDomOrder: true,
      suppressCopyRowsToClipboard: false,
    };
  },
  computed: {
    rowData: {
      get() {
        return this.$store.getters["clientes/getClientes"];
      },
      set(val) {
        this.$store.commit("clientes/setClientes", val);
      },
    },
    quickFilterValue: {
      get() {
        return this.$store.getters["clientes/getQuickFilter"];
      },
      set(value) {
        this.$store.dispatch("clientes/setQuickFilter", value);
      },
    },
  },

  methods: {
    historialContratos() {
      this.$router.push("/admin/clientes/historial-contratos");
    },
    crearCliente() {
      this.$router.push("/admin/clientes/nuevo");
    },
    onGridReady(params) {
      document.getElementsByClassName("ag-watermark")[0].style.display = "none";

      this.gridApi = params.api;
      this.columnApi = params.columnApi;

      this.getClientes().then(() => {
        this.applyQuickFilter();
      });
    },
    applyQuickFilter() {
      if (this.gridApi && this.quickFilterValue) {
        this.gridApi.setQuickFilter(this.quickFilterValue);
      } else {
        this.gridApi.setQuickFilter("");
      }
    },
    async getClientes() {
      this.gridApi.showLoadingOverlay();
      this.$store.dispatch("clientes/getClientes").then((resp) => {
        if (!resp.ok) {
          this.$msgBoxOk(resp.message);
        }
        this.gridApi.hideOverlay();
        setTimeout(() => this.autoSizeAll(false), 50);
      });
    },
    autoSizeAll(skipHeader) {
      let allColumnIds = [];
      this.columnApi.getAllColumns().forEach(function (column) {
        allColumnIds.push(column.colId);
      });
      this.columnApi.autoSizeColumns(allColumnIds, skipHeader);
    },
    altaDeCliente() {
      this.$refs.altaDeClientes.$refs.modal.show();
    },
    resumenDeClientes() {
      this.$refs.resumenDeClientes.$refs.modal.show();
    },
    modificarCliente(node) {
      this.modifyClienteNodeId = node.id;
      this.$store.commit("clientes/setClienteForModify", {
        ...node.data,
        fecha_ingreso: this.$moment(node.data.fecha_ingreso).format(
          "YYYY-MM-DDTHH:mm:ss",
        ),
        fecha_baja: this.$moment(node.data.fecha_baja).format(
          "YYYY-MM-DDTHH:mm:ss",
        ),
      });
      this.$refs.modificarCliente.$refs.modal.show();
    },
    clienteUpdated(clienteData) {
      let node = this.gridApi.getRowNode(this.modifyClienteNodeId);
      node.setData(clienteData);
      this.modifyClienteNodeId = null;
    },
    getContextMenuItems() {
      return ["copy", "excelExport"];
    },
  },
  data: () => ({
    modifyClienteNodeId: null,

    // ag-grid config
    modules: AllModules,

    gridOptions: null,
    gridApi: null,
    columnApi: null,

    defaultColDef: null,
    columnDefs: [
      {
        headerName: "id",
        field: "id_cliente",
        filter: false,
        sort: "asc",
        comparator: (a, b) => {
          const numA = parseInt(a);
          const numB = parseInt(b);
          return numA - numB;
        },
      },
      {
        headerName: "Apell y Nombre",
        valueGetter: (params) =>
          `${params.data.apellido || ""} ${params.data.nombre}`,
        hide: true,
      },
      {
        headerName: "Nombre Web",
        field: "nombre_web",
      },
      {
        headerName: "Tel personal",
        field: "cel_personal",
        hide: true,
      },
      {
        headerName: "# Empresas",
        field: "empresas_count",
        hide: true,
      },
      {
        headerName: "# Contratos",
        field: "contratos_count",
        hide: true,
      },
      {
        headerName: "Email Facturación - Gerencia",
        valueGetter: (params) => `${params.data.email_facturacion || " - "}
        ${params.data.email_gerencia || " "}`,
        hide: true,
      },
      {
        headerName: "Usuario",
        field: "nombre_usuario",
        hide: true,
      },
      {
        headerName: "Password",
        field: "password",
        hide: true,
      },
      {
        headerName: "Actions",
        cellRendererFramework: ClientesTablaActions,
      },
      {
        headerName: "Registro Validado",
        cellRenderer: (params) => {
          return params.frameworkComponentWrapper.parent
            .$moment(params.data.fecha_ingreso)
            .format("DD-MM-YYYY");
        },
        comparator: (valueA, valueB, nodeA, nodeB) => {
          return (
            new Date(nodeA.data.fecha_ingreso.substring(0, 10)) -
            new Date(nodeB.data.fecha_ingreso.substring(0, 10))
          );
        },
        hide: true,
        flex: 3,
      },
    ],
  }),
  watch: {
    quickFilterValue() {
      this.getClientes().then(() => {
        this.applyQuickFilter();
      });
    },
  },
};
</script>
<style></style>
